import { createReducer } from "@reduxjs/toolkit";
import {
  resetEducationalAdvisorRetrieveEvaluationsByTrainingItem,
  educationalAdvisorRetrieveEvaluationsByTrainingItem,
} from "./retrieve-evaluations-by-training-item";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TrainingItemEvaluationVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const initialState: RetrievalState<TrainingItemEvaluationVM[]> = { fetching: "idle", data: [] };

export const educationalAdvisorRetrieveEvaluationsByTrainingItemReducer = createReducer<RetrievalState<TrainingItemEvaluationVM[]>>(
  initialState,
  builder => {
    builder.addCase(educationalAdvisorRetrieveEvaluationsByTrainingItem.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(educationalAdvisorRetrieveEvaluationsByTrainingItem.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(educationalAdvisorRetrieveEvaluationsByTrainingItem.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetEducationalAdvisorRetrieveEvaluationsByTrainingItem, () => {
      return initialState;
    });
  },
);
